import isFunction from './isFunction';

export default function(_) {
  return isFunction(_) ? _ : function() { return _; };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-lite/node_modules/vega-util/src/constant.js
// module id = null
// module chunks = 